export const mutations = {
  SET_MEMBERINFO (state, payload) {
    state.memberInfo = payload
  },
  SET_MEMBER_POINT (state, payload) {
    state.memberInfo.collectPoint = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/member/mutations.js